<template>
  <div id="app">
    <jumbotron>
      <h1>Los Angeles Based UI/UX Software Engineer</h1>
      <h2>I build scalable, accessible front-end architecture for web applications.</h2>
      <social-menu />
    </jumbotron>

    <div class="container margin-top--lv4">
      <post-list :posts="blog.posts" :h-level="4" />
    </div>
  </div>
</template>

<script>
import { get, call } from 'vuex-pathify'
import RouteGetters from '@/mixins/RouteGetters'
import Jumbotron from '@/views/components/Jumbotron'
import PostList from '@/views/components/PostList'
import socialMenu from '@/views/components/socialMenu'

export default {
  mixins: [RouteGetters],
  components: {
    Jumbotron,
    PostList,
    socialMenu
  },
  head: {
    title: function () {
      return {
        inner: this.route.meta.title
      }
    }
  },
  computed: {
    blog: get('Blog')
  },
  methods: {
    fetchCategories: call('Blog/fetchCategories'),
    fetchPosts: call('Blog/fetchPosts')
  },
  mounted () {
    let params = {
      'filter[orderby]': '',
      'filter[posts_per_page]': 10,
      'filter[paged]': 1,
      'orderby': 'date',
      '_embed': ''
    }

    this.fetchCategories()
    this.fetchPosts(params)
  }
}
</script>

<style lang="scss" scoped></style>
